import React from 'react';
import { Route, Switch } from 'react-router-dom';

import NotFound from 'containers/Error/E404';
import List from './List';
import Lead from 'containers/Lead';
const indexLead = (props) => {
  const { match } = props; // eslint-disable-line
  return (
    <Switch>
      <Route exact path={match.url} component={List} />
      <Route path={`${match.url}/:prefix`} component={Lead} />
      <Route component={NotFound} />
    </Switch>
  );
};

// Module exports
export default indexLead;
